export default {"src":"/_next/static/media/modern-north-arrow.56072ff8.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};